import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from '../services/products.service';
import { Product } from '../services/product';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent {
  public product: Product
  public videoUrl?: SafeUrl

  @Input() set selected(value: number) {
    this.product = this.productsService.products[value]
    if (this.product.videoUrl) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        "https://www.youtube.com/embed/" + this.product.videoUrl
        + '?autoplay=1&mute=1&loop=1&controls=0&playlist=' + this.product.videoUrl)
    }
  }

  constructor(private productsService: ProductsService, private sanitizer: DomSanitizer) { }
}
